import { omit } from 'lodash';

import { useCSVDownloader } from 'react-papaparse';

import { Controller, useForm, useWatch } from 'react-hook-form';

import { Button } from 'ui';
import RadioField from 'ui/form/RadioField';
import { useLoading } from 'ui/contexts/overlay/Loading';
import { ModalFormProps, ModalProps } from 'ui/models/overlay';

import { ContactGroupsExportType } from 'contactGroups/models/contactGroups';

type Props = {
  modal: ModalProps;
  onClickContinue?: () => void;
  onClickCloseModal: () => void;
  ModalOverlay: (any: ModalFormProps) => JSX.Element;
};

type ExportModalFields = {
  contactGroupsExportType: ContactGroupsExportType;
};

export default function ContactGroupsExportModal({
  modal,
  ModalOverlay,
  onClickContinue,
  onClickCloseModal,
}: Props) {
  const { control } = useForm<ExportModalFields>();

  const { LoadingOverlay } = useLoading();
  const { CSVDownloader, Type } = useCSVDownloader();

  const MODAL_EXPORT_TYPE_OPTIONS = [
    {
      label: 'Resumido',
      value: ContactGroupsExportType.SUMMEDUP,
    },
    {
      label: 'Com Detalhes',
      value: ContactGroupsExportType.DETAILED,
    },
  ];

  const [contactGroupsExportType] = useWatch({
    control,
    name: ['contactGroupsExportType'],
  });

  return (
    <ModalOverlay title={modal.title} variant={modal.variant}>
      <div className="flex flex-col gap-2 p-4">
        <p className="text-gray-dark400 font-small text-sm font-semibold">
          {modal.text}
        </p>
        <div className="flex gap-4">
          <Controller
            control={control}
            name="contactGroupsExportType"
            render={({ field: { ref, value, onChange } }) => (
              <RadioField
                {...omit(ref, 'ref', 'value')}
                value={value}
                onChange={onChange}
                id="contactGroupsExportType"
                options={MODAL_EXPORT_TYPE_OPTIONS}
              />
            )}
          />
        </div>
      </div>
      <div className="flex w-full items-center justify-end flex-row-reverse mt-8 gap-4">
        <CSVDownloader
          data={
            /* REFACTOR: WE NEED TO INCLUDE THE RIGHT DATA BELLOW */
            (contactGroupsExportType === ContactGroupsExportType.SUMMEDUP && [
              ['SUMMED'],
            ]) ||
            (contactGroupsExportType === ContactGroupsExportType.DETAILED && [
              ['DETAILED'],
            ])
          }
          bom={true}
          type={Type.Link}
          filename="Relatório de Grupos & Contatos"
          config={{
            delimiter: ';',
          }}
        >
          <Button
            size="md"
            variant="primaryGreen"
            disabled={!contactGroupsExportType}
            onClick={contactGroupsExportType && onClickContinue}
          >
            <p className="font-bold">Baixar</p>
          </Button>
        </CSVDownloader>

        <Button variant="primaryGray" size="md" onClick={onClickCloseModal}>
          <p className="font-medium ">Cancelar</p>
        </Button>
      </div>
      <LoadingOverlay />
    </ModalOverlay>
  );
}
